import { TireSetDemountSceneProps, TireSetDemountStepText } from "./types";

export const TIRE_SET_DEMOUNT_WAREHOUSE_STEP = 0;
export const TIRE_SET_DEMOUNT_NEW_SET_STEP = 1;
export const TIRE_SET_DEMOUNT_SUMMARY_STEP = 2;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const TIRE_SET_DEMOUNT_INTRO_TEXTS: Record<number, TireSetDemountStepText> = {
  [TIRE_SET_DEMOUNT_WAREHOUSE_STEP]: {
    title: "Kamo ide skinuti set?",
    description: "Odaberite skladište i datum demontaže. Set se skida s vozila i dobiva mjesto na polici.",
  },
  [TIRE_SET_DEMOUNT_NEW_SET_STEP]: {
    title: "Novi set za vozilo",
    description: "Vozilo uvijek mora imati montirane gume. Odaberite set sa skladišta koji ide na vozilo.",
  },
  [TIRE_SET_DEMOUNT_SUMMARY_STEP]: {
    title: "Provjerite demontažu",
    description: "Pregledajte zamjenu prije potvrde. Obje promjene lokacije ostaju zapisane u povijesti.",
  },
};

/** Primjeri dok korisnik ništa nije odabrao. */
export const TIRE_SET_DEMOUNT_INTRO_SAMPLE = {
  vehicleName: "Škoda Octavia",
  vehicleRegistration: "ZG 1234 AB",
  vehicleImage: "/media/images/vehicles/vehicle-2.png",
  warehouseName: "Skladište Sesvete",
  newSetCode: "SET 0017",
  newSetDimension: "205/55 R16",
};

/** Najmanja dubina profila (mm) s kojom se set još sprema za iduću sezonu. */
export const TIRE_SET_DEMOUNT_MIN_PROFILE_DEPTH = 4;

/** Oznaka kad je skladište ili set odabran, a naziv još nije razriješen. */
export const TIRE_SET_DEMOUNT_SELECTED_WAREHOUSE = "Odabrano skladište";
export const TIRE_SET_DEMOUNT_SELECTED_SET = "Odabrani set";

/** Vozilo s kojeg se set skida: vozilo seta ili primjer. */
export const getDemountVehicle = ({ currentSet }: TireSetDemountSceneProps) => ({
  name: currentSet.vehicle?.name || TIRE_SET_DEMOUNT_INTRO_SAMPLE.vehicleName,
  registration: currentSet.vehicle?.registrationPlate || TIRE_SET_DEMOUNT_INTRO_SAMPLE.vehicleRegistration,
  image: currentSet.vehicle?.defaultImage || TIRE_SET_DEMOUNT_INTRO_SAMPLE.vehicleImage,
});

/** Odredišno skladište: razriješeno, oznaka odabira ili primjer. */
export const getDemountWarehouse = ({ formValues, targetWarehouseName }: TireSetDemountSceneProps) =>
  targetWarehouseName ||
  (formValues.targetWarehouseId ? TIRE_SET_DEMOUNT_SELECTED_WAREHOUSE : TIRE_SET_DEMOUNT_INTRO_SAMPLE.warehouseName);

/** Novi set za vozilo: razriješen, oznaka odabira ili primjer. */
export const getDemountNewSet = ({ formValues, newSetCode, newSetDimension }: TireSetDemountSceneProps) => {
  if (newSetCode) {
    return { code: newSetCode, dimension: newSetDimension || "" };
  }
  return formValues.newTireSetId
    ? { code: TIRE_SET_DEMOUNT_SELECTED_SET, dimension: "" }
    : { code: TIRE_SET_DEMOUNT_INTRO_SAMPLE.newSetCode, dimension: TIRE_SET_DEMOUNT_INTRO_SAMPLE.newSetDimension };
};
